import axios from "./axiosInstance";

const permissionsAPI = {
  getDetails: () => axios.get("permissions/"),

  addDetails: (payload) => axios.post("permissions/", payload),
  
  getSingleDetails: (id) => axios.get(`permissions/${id}`),
};

export default permissionsAPI;
